import { ComponentProps } from "react";

import { Currency, amountAsCurrency } from "currency";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  price: number;
  priceNotDiscounted: number | null;
  currency: Currency;
  textProps?: Omit<ComponentProps<typeof Text>, "children">;
};

export default function DiscountablePriceText({
  price,
  priceNotDiscounted,
  currency,
  textProps,
}: Props) {
  const tailwind = useTailwind();
  const amount = amountAsCurrency({ amount: price, currency });

  if (!priceNotDiscounted) {
    return <Text {...textProps}>{amount}</Text>;
  }

  return (
    <Text {...textProps}>
      {`${amount} `}
      <Text {...textProps} style={[textProps?.style, tailwind("line-through")]}>
        {amountAsCurrency({ amount: priceNotDiscounted, currency })}
      </Text>
    </Text>
  );
}
